function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStreamlineIconArrowRight1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19.5 12c0 .7-.3 1.3-.8 1.7L7.5 23.6c-.8.7-2 .6-2.6-.2s-.6-1.9.2-2.6l9.8-8.6c.1-.1.1-.2 0-.4L5.1 3.2c-.8-.7-.8-1.9-.1-2.6S6.8-.2 7.6.4l11.2 9.8c.4.5.7 1.1.7 1.8",
  style: {
    fill: "#000"
  }
}));
export default SvgStreamlineIconArrowRight1;